export default {
    paymentSucceeded: 'Payment successful!<br> You can now close this window and return to Bookli.',
    paymentFailed: 'Payment failed.<br> Close this window and return to Bookli to try again.',
    paymentProcessFinished: 'The payment process has finished.<br> You can now close this window and return to Bookli.'
}